export default __webpack_public_path__ + "static/compareItemImg4-e227b723aa34c6d543bb6aa553f536be.webp";